import { IFilterMultiSelectOption } from 'transfix-ui/components/FilterMultiSelect'
import { getFilterMultiSelectedValues } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/components/filters/utils/getFilterMultiSelectedValues'
import { TQuoteFilters } from 'apps/marketplace/pages/spot-quote-tool/historical-quotes/types'

interface IUseDropTypeProps {
  quotesFilters: TQuoteFilters
  setQuotesFilters: React.Dispatch<React.SetStateAction<TQuoteFilters>>
}

const DROP_DROP_TYPE = 'drop_drop'
const DROP_LIVE_TYPE = 'drop_live'
const LIVE_DROP_TYPE = 'live_drop'
const LIVE_LIVE_TYPE = 'live_live'

export const useDropType = ({ quotesFilters, setQuotesFilters }: IUseDropTypeProps) => {
  const getDropTypeFilterOptions = (quotesFilters: TQuoteFilters) => {
    const dropTypeOptions: IFilterMultiSelectOption[] = [
      {
        value: LIVE_LIVE_TYPE,
        label: 'Live - Live',
        selected: quotesFilters.dropType.includes(LIVE_LIVE_TYPE),
      },
      {
        value: DROP_LIVE_TYPE,
        label: 'Drop - Live',
        selected: quotesFilters.dropType.includes(DROP_LIVE_TYPE),
      },
      {
        value: LIVE_DROP_TYPE,
        label: 'Live - Drop',
        selected: quotesFilters.dropType.includes(LIVE_DROP_TYPE),
      },
      {
        value: DROP_DROP_TYPE,
        label: 'Drop - Drop',
        selected: quotesFilters.dropType.includes(DROP_DROP_TYPE),
      },
    ]
    return dropTypeOptions
  }

  const dropTypeHandler = (selected?: IFilterMultiSelectOption[]) => {
    if (selected) {
      const dropType = getFilterMultiSelectedValues(selected)
      const updatedFilters = {
        ...quotesFilters,
        dropType,
      }
      setQuotesFilters(updatedFilters)
    }
  }

  const dropTypeOptions = getDropTypeFilterOptions(quotesFilters)

  return { dropTypeOptions, dropTypeHandler }
}
